import * as React from 'react'
import styled from 'styled-components'
import { websitePrivacyLink } from '../CardConsent/CardConsent'

const ContentWrapper = styled.div``

const Title = styled.h2`
  font-size: 1rem;
  font-weight: var(--font-weight-bold);
  text-align: center;
  margin-top: 0;
`

const Description = styled.p`
  font-size: 0.875rem;
`

const PrivacyPolicyLink = styled.a`
  color: var(--color-primary);
`

export const ConsentTitle = () => `GCash Consent and Transaction Monitoring`

export const ConsentDescription = () => (
  <>
    By linking and registering your GCash account, you consent and authorize
    Ayalaland Malls, Inc. (ALMI), (the “Company”) to share your mobile number
    with G-XCHANGE, INC. (“GCash”) for the purposes of this program. You consent
    to and authorize GCash to monitor transaction on your linked GCash account
    to determine when you have made a qualifying transaction, and for GCash to
    share or transfer (including overseas transfers) such transaction details
    with/to the Company, and third-party developers for the purposes of this
    program, and to enable account-linked offer(s) and target offers that may be
    of interest to you. For information about the Company’s privacy practices,
    please see&nbsp;
    <PrivacyPolicyLink
      href={websitePrivacyLink}
      target="_blank"
      rel="noopener noreferrer"
    >
      Privacy Notice
    </PrivacyPolicyLink>
    .&nbsp;In addition to your rights as stated in the&nbsp;
    <PrivacyPolicyLink
      href={websitePrivacyLink}
      target="_blank"
      rel="noopener noreferrer"
    >
      Privacy Notice
    </PrivacyPolicyLink>
    ,&nbsp; you may opt-out of transaction monitoring on your GCash account by
    unlinking your GCash account from your profile.
  </>
)

function GCashConsent(props) {
  return (
    <ContentWrapper {...props}>
      <Title>
        <ConsentTitle />
      </Title>
      <Description>
        <ConsentDescription />
      </Description>
    </ContentWrapper>
  )
}

export default GCashConsent
